import CompactTaskList from './CompactTaskList';

export default CompactTaskList;
